export const $dom = {
  //返回顶部框架  attr是返回到的位置
  fanhui(number) {
    const attr = number || 0;
    this.scrollTop_timer = null;
    this.fanhuiMove(attr);
  },
  //返回顶部的运动
  fanhuiMove(attr) {
    const _this = this;
    clearInterval(_this.scrollTop_timer);
    this.scrollTop_timer = setInterval(function () {
      _this.fanhuiTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop ||
        0;
      const cur = _this.fanhuiTop;
      let speed = (attr - cur) / 6;
      speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed);
      if (Math.abs(cur - attr) < 10) {
        clearInterval(_this.scrollTop_timer);
      }
      document.documentElement.scrollTop = cur + speed;
      document.body.scrollTop = cur + speed;
    }, 15);
  },
};
